import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const HomeIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </SvgIcon>
);

export default HomeIcon;
